import axios from 'axios';

class Api {
  constructor() {
    this.processing = false;
    this.doNotIncludeEmployees = false;
  }

  withoutEmployees() {
    this.doNotIncludeEmployees = true;

    return this;
  }

  groups() {
    let url = '/employee-group';

    if (this.doNotIncludeEmployees) {
      url = `${url}?without-employees=1`;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(({ data }) => {
          this.processing = false;
          resolve(data.data);
        })
        .catch(error => {
          this.processing = false;
          reject(error.response);
        });
    });
  }

  syncEmployees(group_id, employee_ids) {
    this.processing = true;

    return new Promise((resolve, reject) => {
      axios
        .patch(`/employee-group/${group_id}`, {
          employee_ids
        })
        .then(({ data }) => {
          this.processing = false;
          resolve(data.group.data.employees.data);
        })
        .catch(error => {
          this.processing = false;
          reject(error.response);
        });
    });
  }
}

export default Api;
